'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscGraphBox = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M13 7h-2v10h2V7ZM17 10h-2v7h2v-7ZM9 13H7v4h2v-4Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M3 3v18h18V3H3Zm16 16H5V5h14v14Z" })
);

module.exports = SvgMiscGraphBox;
//# sourceMappingURL=MiscGraphBox.cjs.js.map
